import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { isEmpty } from 'lodash';
import style from '../styles/index.scss';
import ConfigDetails from './ConfigDetails';
import { EllipsisBlock } from '../../../../../cm/common/styled';

const HeaderDetails = ({
  typology,
  combinations,
  handleDropdown,
  panelIndex
}) => {
  const [dropDownOptions, setOptions] = useState([]);
  const [entries, setEntries] = useState([]);
  const [selectedDropDown, setSelectedDropDown] = useState('');

  useMemo(() => {
    let options = [];
    combinations.map((option, index) => {
      index++;
      let label = `Set - ${option?.title}`;
      options.push({ label: label, value: option?.id });
    });

    setOptions(options);
    setEntries(combinations?.[0]?.entries ?? []);
    setSelectedDropDown(combinations?.[0]?.id ?? '');
  }, [combinations]);

  const handleChange = (typologyId, value) => {
    let selectedCombination = combinations.find(
      (combination) => combination?.id === value
    );
    setEntries(
      isEmpty(selectedCombination) ? [] : selectedCombination?.entries
    );
    setSelectedDropDown(selectedCombination?.id ?? '');
    handleDropdown(panelIndex, typologyId, value);
  };

  return (
    <div className={style.headerContainer}>
      <div className={style.headerTitles}>
        <EllipsisBlock title={typology?.title}>{typology?.title}</EllipsisBlock>
        {/* <p className={style.noteSpan}>{getNotes(typology?.id)}</p> */}
      </div>

      <div className={style.combinationContainer}>
        <Select
          style={{ width: '100%' }}
          onChange={(value) => handleChange(typology?.id, value)}
          onClick={(e) => {
            e.stopPropagation();
          }}
          options={dropDownOptions}
          value={selectedDropDown}
        />
        <ConfigDetails entries={entries} />
      </div>
    </div>
  );
};

HeaderDetails.propTypes = {
  typology: PropTypes.object,
  combinations: PropTypes.array,
  handleDropdown: PropTypes.func,
  panelIndex: PropTypes.number
};

export default HeaderDetails;
